import React, { useState, useEffect } from 'react';
import { Container, Col, Row, Modal, Button, Card } from 'react-bootstrap';
import styles from './editSheduledInterviewsModal.module.scss';
import InterviewConfigurations from './interviewConfigurations';
import CSSLoader from '../../../../shared/cssLoader';
import Review from './review';


const EditSheduledInterviewsModal = (props) => {
    let [step, setStep] = useState(1);
    let [interviewers, setInterviewers] = useState();
    let [values, setValues] = useState(props.editRowValues);
    let [timeZone, setTimeZone] = useState({
        label: props.editRowValues.time_zone,
        value: props.editRowValues.time_zone,
    });

    let [isLoading, setLoading] = useState(false);

    function nextPage(value) {
        setStep(value);
    }
    function previousPage(value) {
        setStep(value);
    }

    function updateValues(val) {
        setValues((prevState) => ({
            ...prevState,
            shedule_date: val.dateTime,
            interview_type: val.interviewType,
            interview_location_address: val.address,
            guidelineDescription: val.guidelineDescription,
        }));
        setInterviewers(val.interviewers);
        setTimeZone(val.timezone);
    }

    function updateInterviewType(val) {
        setValues((prevState) => ({
            ...prevState,
            interview_type: val,
        }));
    }




    useEffect(() => {
        let unmounted = false;
        const setInterviwersValues = async () => {
            if (!unmounted) {
                setLoading(true)
                let dataArray = [];
                await (props.editRowValues.assigned_interviewers).forEach(element => {
                    dataArray.push({
                        user_id: {
                            email: element.interviewer_email,
                            name: element.interviewer_name,
                        },
                        _id: element.interviewer_id,
                    })
                });
                await setInterviewers(dataArray);
            }
            setLoading(false)
        }
        setInterviwersValues();
        return () => { unmounted = true };
    }, []);


    return (
        <div>

            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Edit Scheduled Interview</h2>
                    </div>
                    <Container>
                        <div className="mb-4">
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    CANDIDATE DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Name</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{values.candidate_name}</p>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Email</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{values.candidate_email}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Phone</p>
                                        </Col>
                                        <Col>
                                            {(values.country_code && values.mnumber) ?
                                                <p className={styles.cardValues}>({values.country_code})&nbsp;{values.mnumber}</p>
                                                :
                                                <p className={styles.cardValues}>Not available</p>
                                            }

                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>
                        <div>
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    VACANCY DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Pipeline Name</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{values.pipeline_name}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Position</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{values.position}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>
                    </Container>

                    <Col sm={{ span: 6, offset: 3 }} className={styles.stepPosition}>
                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                            <div className={styles.stepActive}>1</div>
                            <div className={(step === 2) ? styles.stepActive : ''}>2</div>
                        </div>
                    </Col>

                    <Container>
                        <div>
                            <p className={styles.stepSubtopicName}>
                                {
                                    step === 1 ? 'Interview Configurations'
                                        : 'Review'
                                }
                            </p>
                        </div>
                    </Container>

                    {
                        isLoading === true ?
                            (<div>
                                <Col sm={{ span: 4, offset: 4 }}>
                                    <CSSLoader />
                                </Col>
                            </div>)
                            :
                            (<Container>
                                {/* Rendering Content Goes Here */}
                                {step === 1 && props.showModal === true && <InterviewConfigurations nextPage={nextPage} updateValues={updateValues} interviewers={interviewers} values={values} updateInterviewType={updateInterviewType} timeZone={timeZone} />}
                                {step === 2 && props.showModal === true && <Review previousPage={previousPage} handleClose={props.handleClose} interviewers={interviewers} timeZone={timeZone} values={values} getAllSheduledInterviewValues={props.getAllSheduledInterviewValues} />}
                            </Container>)
                    }
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default EditSheduledInterviewsModal;
